import { APIClient } from "./axiosClient";

export class AuthApi {
    static Login(body: { username: string, password: string }) {
        return APIClient('/user/doLogin', body, { requestType: 'post', withCredentials: true });
    }

    static doLogout() {
        return APIClient('/user/doLogout', {}, { requestType: 'post', withCredentials: true });
    }

    static forgotPassword(email: string) {
        return APIClient('/user/forgotPassword', { username: email }, { requestType: 'post', withCredentials: true });
    }

    static initiateResetPassword(email: string, resetPasswordCode: string) {
        return APIClient('/user/initiateResetPassword', { email, resetPasswordCode }, { requestType: 'post', withCredentials: true });
    }

    static resetPassword(email: string, newPassword: string, resetPasswordToken: string) {
        return APIClient('/user/resetPassword', { email, newPassword, resetPasswordToken }, { requestType: 'post', withCredentials: true });
    }
}